// extracted by mini-css-extract-plugin
export default {"acknowledgement":"_hq57","successAck":"zus8Y","inputs":"l_duZ"};